import { graphql } from '@/gql'

export const JobFragment = graphql(/* GraphQL */ `
  fragment Job on Job {
    id
    company {
      id
    }
    viewerCanEdit
    viewerCanShare
    viewerCanCreateJobCandidate
    viewerCanCreateHire
    published
    isForRecruiters
    isForMarketplace
    available
    recruiterShares: shares(isActive: true, accountTypes: [RECRUITER]) {
      paginatorInfo {
        total
      }
    }
    workerShares: shares(isActive: true, accountTypes: [WORKER]) {
      paginatorInfo {
        total
      }
    }
  }
`)

export const JobCandidateFragment = graphql(/* GraphQL */ `
  fragment JobCandidate on JobCandidate {
    id
    worker {
      id
      name
      jobTitle
      profile {
        url
      }
      hiresWithAttribution {
        recruiter {
          name
        }
        recruiterFee
        recruiterManagesWorkers
        recruiterOwnershipStartDate
        recruiterOwnershipDays
        recruiterOwnershipDaysLeft
      }
    }
    bid {
      id
      conversation {
        id
        url
      }
      message {
        id
        url
      }
      worker {
        id
        name
      }
      supplier {
        id
        name
      }
    }
    jobShare {
      id
      isActive
    }
    job {
      conversations(first: $first) {
        data {
          id
          url
          participants(first: $first, accountTypes: [WORKER]) {
            data {
              id
              account {
                id
              }
            }
          }
        }
      }
    }
    jobShare {
      id
      isActive
    }
    sourcingChannel
    owner {
      name
    }
    step
    status
    createdAt
    updatedAt
    statusReason
    statusComment
    isPreferred
    viewerCanUpdateStatus
    viewerCanUpdatePreferred
  }
`)

export const JobFormDataFragment = graphql(/* GraphQL */ `
  fragment JobFormData on Job {
    id
    company {
      id
      currency
      settings {
        multiCurrencyContractsDisabled
      }
      address {
        address
        postCode
        city
        state
        country {
          isoCode
        }
      }
    }
    name
    description
    startDate
    endDate
    startDateTimeframe
    endDateTimeframe
    updatedAt
    locationPreference
    address
    location {
      address
      postCode
      city
      state
      country {
        isoCode
      }
    }
    rateType
    rate
    minimumRate
    maximumRate
    association
    visibility
    skills {
      name
    }
    industries {
      id
      name
    }
    attachments {
      id
      name
      storageName: name
    }
    removed
    available
    published
    approved
    paused
    completed
    isExtensionAvailable
    expectedExperienceLevel
    viewerCanDelete
    isForMarketplace
    evaluationPeriod
    internalBudget
    project {
      id
    }
    owners {
      id
      avatar
      name
    }
    languages {
      ...JobLanguage
    }
    customFieldValues {
      ...FieldableFormCustomFieldValue
    }
    requiredWorkers
    canBePublished
  }
`)

export const JobLanguageFragment = graphql(/* GraphQL */ `
  fragment JobLanguage on Language {
    name
    experience
  }
`)

export const JobFormShareWorkerFragment = graphql(/* GraphQL */ `
  fragment JobFormShareWorker on JobShare {
    id
    account {
      ...JobFormShareableWorker
    }
  }
`)

export const JobFormShareRecruiterFragment = graphql(/* GraphQL */ `
  fragment JobFormShareRecruiter on JobShare {
    id
    account {
      ...JobFormShareableRecruiter
    }
  }
`)

export const JobFormShareableWorkerFragment = graphql(/* GraphQL */ `
  fragment JobFormShareableWorker on Worker {
    id
    name
    avatar
    jobTitle
  }
`)

export const JobFormShareableRecruiterFragment = graphql(/* GraphQL */ `
  fragment JobFormShareableRecruiter on Recruiter {
    id
    name
    avatar
  }
`)
